/*
 * Jira Ticket:
 * Created Date: Mon, 24th Jan 2022, 15:07:53 pm
 * Author: Rafiul Ansari
 * Email: raf.ansari@thedistance.co.uk
 * Copyright (c) 2022 The Distance
 */

import { fetchStart, fetchEnd } from 'react-admin';

export default function getAllCapabilities({
  dataProvider,
  dispatch,
  notify,
  setCapabilities,
}) {
  return () => {
    let isSubscribed = true;
    dispatch(fetchStart());
    dataProvider('GET_LIST', 'Capabilities', {})
      .then(result => {
        if (isSubscribed) setCapabilities(result.data);
      })
      .catch(error => {
        const {
          extensions: { code },
          message,
        } = error.graphQLErrors[0];
        if (code !== 'INTERNAL_SERVER_ERROR') {
          notify(message, 'warning');
        }
        notify('error.subscriptionTier.unableToGetCapabilities', 'warning');
      })
      .finally(() => {
        dispatch(fetchEnd());
      });

    return () => (isSubscribed = false);
  };
}
